import React, { useState } from 'react';
import { Box, Tabs, Tab, Typography, Grid, Chip, Stack } from '@mui/material';
import { years, teaching } from '../data';
import { Section, Heading } from './common';

const Curriculum = () => {
  const [i, setI] = useState(0);
  const y = years[i];
  return (
    <Section id="curriculum" bg="#ffffff">
      <Heading title="Four years, from basic sciences to specialised practice" text="Each year builds on the last, moving from how the body works to how to treat patients." />
      <Tabs
        value={i}
        onChange={(e, v) => setI(v)}
        variant="scrollable"
        scrollButtons="auto"
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 5, '& .MuiTab-root': { fontWeight: 700, fontSize: '1rem', textTransform: 'none', minHeight: 56 } }}
      >
        {years.map((t) => <Tab key={t.year} label={t.year} />)}
      </Tabs>

      <Grid container spacing={{ xs: 4, md: 8 }}>
        <Grid item xs={12} md={5}>
          <Typography variant="h4" sx={{ color: 'primary.dark', mb: 2 }}>{y.title}</Typography>
          <Typography sx={{ color: 'text.secondary', lineHeight: 1.8, fontSize: '1.08rem' }}>{y.text}</Typography>
        </Grid>
        <Grid item xs={12} md={7}>
          <Stack direction="row" flexWrap="wrap" gap={1.5}>
            {y.subjects.map((s) => (
              <Chip key={s} label={s} sx={{ bgcolor: 'background.default', color: 'primary.dark', fontWeight: 600, fontSize: '0.98rem', height: 44, borderRadius: '6px', px: 1 }} />
            ))}
          </Stack>
        </Grid>
      </Grid>

      <Box sx={{ mt: 8, p: { xs: 3, md: 4 }, bgcolor: 'primary.dark', borderRadius: '12px', color: '#fff' }}>
        <Typography variant="h5" sx={{ mb: 1 }}>How you will learn</Typography>
        <Typography sx={{ color: 'rgba(255,255,255,0.75)', mb: 3 }}>Theory and clinical practice run side by side.</Typography>
        <Stack direction="row" flexWrap="wrap" gap={1.5}>
          {teaching.map((t) => (
            <Chip key={t} label={t} variant="outlined" sx={{ color: '#fff', borderColor: 'rgba(255,255,255,0.4)', fontWeight: 600 }} />
          ))}
        </Stack>
      </Box>
    </Section>
  );
};

export default Curriculum;
